import React, { useState} from 'react';
import ChangePassword from './ChangePassword'

type ProfileTabs = {
    name: string;
    label: string;
}

const tabs: ProfileTabs[] = [
    {
        name: 'Change Password',
        label: 'change-password'
    },
   
]

const Settings =()=>{

    const [activeTab, setActiveTab] = useState<string>(tabs[0].label);

    const handleTabChange = (tab: string) => {
        setActiveTab(tab);
    };

    const renderTabs = () => {
        let finalTab = tabs.map((tab: ProfileTabs) => {
            return (
                <div
                    className="tab-style mr-5 "
                    key={tab.label}
                    onClick={() => { handleTabChange(tab.label) }}
                >
                    <div className={`tab-header ${activeTab === tab.label ? "active" : ""}`}>{tab.name}</div>
                    <div
                        className={`${activeTab === tab.label
                            ? "active-tab-bottom-border"
                            : "not-active-tab-bottom-border"
                            }`}
                    ></div>
                </div>
            );
        });

        return finalTab;
    }

    let component = <ChangePassword />



    return(
        <>
         <h2 className="mb-3">Account Settings</h2>
        <div className="tab-container d-flex flex-row justify-content-start align-items-center">
            {renderTabs()}
        </div>
        <div className="tab-detail-container ml-3">
            {component}
        </div>
      </>
    )
}

export default Settings